import serverVars from 'server-vars';
import thunk from 'redux-thunk';

/* Queries */
import { pdpRespRootQuery } from '../../queries/pdpRespRoot';

/* Reducers */
import { defaultReducers } from '../../reducers/reducerUtils';
import { pdpRespPreviewPageReducer as pdpPreviewPage } from '../../reducers/pdpRespPreviewPageReducer';
import { pdpRespPrintReducer as pdpPrint } from '../../reducers/pdpRespPrintReducer';
import { pdpRespNotificationsReducer as sharedNotificationsReducer } from '../../reducers/pdpRespNotificationsReducer';
import { pdpRespSimilarItemsReducer as similarItems } from '../../reducers/pdpRespSimilarItemsReducer';

/* Components */
import { PdpRespLayout } from '../../pdp/PdpRespLayout';

/* Helpers */
import { createEntry } from '../createEntry';
import { initializeDBL } from 'dibs-buyer-layout/src/entries';
import { storePdpVisit } from '../../pdp/PdpSharedNotifications/pdpSharedNotificationHelpers';
import { getItemIdFromUri } from '../../utils/getItemIdFormUri';
import { initUnavailablePdpDatadogRum } from '../../shared/helpers/initUnavailablePdpDatadogRum';

/* Actions */
import { setIsPdpRespPreviewPage } from '../../actions/pdpRespPreviewPageActions';

/* Notifications */
import { pdpRespNotifications } from '../../pdp/PdpRespNotifications/pdpRespNotifications';

const isPdpRespPreviewPage = serverVars.get('isPdpRespPreviewPage');

/**
 * DBL has a different environment that's created in initializeDBL.
 */
const options = {
    autoRunNotificationQueue: !isPdpRespPreviewPage,
    middleware: [thunk],
    notifications: pdpRespNotifications,
    reducers: {
        pdpPrint,
        pdpPreviewPage,
        sharedNotificationsReducer,
        similarItems,
        ...defaultReducers,
    },
};

const itemId = getItemIdFromUri(location.pathname);
if (itemId) {
    storePdpVisit({ itemId });
}

initUnavailablePdpDatadogRum();

initializeDBL(options).then(({ store }) => {
    store.dispatch(setIsPdpRespPreviewPage({ isPdpRespPreviewPage }));
    createEntry({
        Container: PdpRespLayout,
        store,
        query: pdpRespRootQuery,
    });
});
